/* tslint:disable */
/* eslint-disable */
/**
 * EstateEngine.Core.Api - All endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CaseImporterResponsePagedData,
  OrganizationCaseImporterCreateRequest,
  OrganizationCaseImporterResponse,
  OrganizationCaseImporterResponsePagedData,
  OrganizationCaseImporterUpdateRequest,
} from '../models';
import {
    CaseImporterResponsePagedDataFromJSON,
    CaseImporterResponsePagedDataToJSON,
    OrganizationCaseImporterCreateRequestFromJSON,
    OrganizationCaseImporterCreateRequestToJSON,
    OrganizationCaseImporterResponseFromJSON,
    OrganizationCaseImporterResponseToJSON,
    OrganizationCaseImporterResponsePagedDataFromJSON,
    OrganizationCaseImporterResponsePagedDataToJSON,
    OrganizationCaseImporterUpdateRequestFromJSON,
    OrganizationCaseImporterUpdateRequestToJSON,
} from '../models';

export interface CaseImportersDefinitionsGetRequest {
    pageNumber?: number;
    size?: number;
    orderByProperty?: string;
    ascending?: boolean;
    searchTerm?: string;
}

export interface CaseImportersGetRequest {
    pageNumber?: number;
    size?: number;
    orderByProperty?: string;
    ascending?: boolean;
    searchTerm?: string;
    projectId?: string;
}

export interface CaseImportersIdDeleteRequest {
    id: string;
}

export interface CaseImportersIdGetRequest {
    id: string;
}

export interface CaseImportersIdInvokePutRequest {
    id: string;
}

export interface CaseImportersIdPutRequest {
    id: string;
    organizationCaseImporterUpdateRequest?: OrganizationCaseImporterUpdateRequest;
}

export interface CaseImportersIdResetCaseHashesPutRequest {
    id: string;
}

export interface CaseImportersPostRequest {
    organizationCaseImporterCreateRequest?: OrganizationCaseImporterCreateRequest;
}

export interface CaseImportersSearchGetRequest {
    size?: number;
    searchTerm?: string;
}

/**
 * 
 */
export class CaseImportersApi extends runtime.BaseAPI {

    /**
     */
    async caseImportersDefinitionsGetRaw(requestParameters: CaseImportersDefinitionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseImporterResponsePagedData>> {
        const queryParameters: any = {};

        if (requestParameters.pageNumber !== undefined) {
            queryParameters['pageNumber'] = requestParameters.pageNumber;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.orderByProperty !== undefined) {
            queryParameters['orderByProperty'] = requestParameters.orderByProperty;
        }

        if (requestParameters.ascending !== undefined) {
            queryParameters['ascending'] = requestParameters.ascending;
        }

        if (requestParameters.searchTerm !== undefined) {
            queryParameters['searchTerm'] = requestParameters.searchTerm;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/CaseImporters/definitions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseImporterResponsePagedDataFromJSON(jsonValue));
    }

    /**
     */
    async caseImportersDefinitionsGet(requestParameters: CaseImportersDefinitionsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseImporterResponsePagedData> {
        const response = await this.caseImportersDefinitionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseImportersGetRaw(requestParameters: CaseImportersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationCaseImporterResponsePagedData>> {
        const queryParameters: any = {};

        if (requestParameters.pageNumber !== undefined) {
            queryParameters['pageNumber'] = requestParameters.pageNumber;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.orderByProperty !== undefined) {
            queryParameters['orderByProperty'] = requestParameters.orderByProperty;
        }

        if (requestParameters.ascending !== undefined) {
            queryParameters['ascending'] = requestParameters.ascending;
        }

        if (requestParameters.searchTerm !== undefined) {
            queryParameters['searchTerm'] = requestParameters.searchTerm;
        }

        if (requestParameters.projectId !== undefined) {
            queryParameters['projectId'] = requestParameters.projectId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/CaseImporters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationCaseImporterResponsePagedDataFromJSON(jsonValue));
    }

    /**
     */
    async caseImportersGet(requestParameters: CaseImportersGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationCaseImporterResponsePagedData> {
        const response = await this.caseImportersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseImportersIdDeleteRaw(requestParameters: CaseImportersIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationCaseImporterResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling caseImportersIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/CaseImporters/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationCaseImporterResponseFromJSON(jsonValue));
    }

    /**
     */
    async caseImportersIdDelete(requestParameters: CaseImportersIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationCaseImporterResponse> {
        const response = await this.caseImportersIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseImportersIdGetRaw(requestParameters: CaseImportersIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationCaseImporterResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling caseImportersIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/CaseImporters/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationCaseImporterResponseFromJSON(jsonValue));
    }

    /**
     */
    async caseImportersIdGet(requestParameters: CaseImportersIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationCaseImporterResponse> {
        const response = await this.caseImportersIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseImportersIdInvokePutRaw(requestParameters: CaseImportersIdInvokePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationCaseImporterResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling caseImportersIdInvokePut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/CaseImporters/{id}/invoke`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationCaseImporterResponseFromJSON(jsonValue));
    }

    /**
     */
    async caseImportersIdInvokePut(requestParameters: CaseImportersIdInvokePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationCaseImporterResponse> {
        const response = await this.caseImportersIdInvokePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseImportersIdPutRaw(requestParameters: CaseImportersIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationCaseImporterResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling caseImportersIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/CaseImporters/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationCaseImporterUpdateRequestToJSON(requestParameters.organizationCaseImporterUpdateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationCaseImporterResponseFromJSON(jsonValue));
    }

    /**
     */
    async caseImportersIdPut(requestParameters: CaseImportersIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationCaseImporterResponse> {
        const response = await this.caseImportersIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseImportersIdResetCaseHashesPutRaw(requestParameters: CaseImportersIdResetCaseHashesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationCaseImporterResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling caseImportersIdResetCaseHashesPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/CaseImporters/{id}/reset-case-hashes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationCaseImporterResponseFromJSON(jsonValue));
    }

    /**
     */
    async caseImportersIdResetCaseHashesPut(requestParameters: CaseImportersIdResetCaseHashesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationCaseImporterResponse> {
        const response = await this.caseImportersIdResetCaseHashesPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseImportersPostRaw(requestParameters: CaseImportersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationCaseImporterResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/CaseImporters`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationCaseImporterCreateRequestToJSON(requestParameters.organizationCaseImporterCreateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationCaseImporterResponseFromJSON(jsonValue));
    }

    /**
     */
    async caseImportersPost(requestParameters: CaseImportersPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationCaseImporterResponse> {
        const response = await this.caseImportersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseImportersSearchGetRaw(requestParameters: CaseImportersSearchGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrganizationCaseImporterResponse>>> {
        const queryParameters: any = {};

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.searchTerm !== undefined) {
            queryParameters['searchTerm'] = requestParameters.searchTerm;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/CaseImporters/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrganizationCaseImporterResponseFromJSON));
    }

    /**
     */
    async caseImportersSearchGet(requestParameters: CaseImportersSearchGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrganizationCaseImporterResponse>> {
        const response = await this.caseImportersSearchGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
